import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const Lightbox = ({ src, onClose }) => (
  <AnimatePresence>
    {src && (
      <motion.div
        className="fixed inset-0 z-[90] flex items-center justify-center p-4 sm:p-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        data-testid="poster-lightbox"
      >
        <div className="absolute inset-0 bg-[#040d09]/92 backdrop-blur-sm" onClick={onClose} />
        <button
          onClick={onClose}
          data-testid="poster-lightbox-close"
          className="absolute top-5 right-5 z-10 rounded-full bg-[color:var(--kmg-lime)] p-2.5 text-[color:var(--kmg-forest)]"
          aria-label="Close poster"
        >
          <X size={17} />
        </button>
        <motion.img
          key={src}
          src={src}
          alt="KMG Digi Platform poster"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.97, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="relative max-h-full max-w-full object-contain border border-[rgba(111,227,155,0.25)]"
        />
      </motion.div>
    )}
  </AnimatePresence>
);
